module.exports = __webpack_public_path__ + "img/more-invest.5396a149.png";